/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";

export const kbId: msRest.OperationURLParameter = {
  parameterPath: "kbId",
  mapper: {
    required: true,
    serializedName: "kbId",
    type: {
      name: "String"
    }
  }
};
export const runtimeEndpoint: msRest.OperationURLParameter = {
  parameterPath: "runtimeEndpoint",
  mapper: {
    required: true,
    serializedName: "RuntimeEndpoint",
    defaultValue: '',
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
